"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceCards = void 0;
// @ts-ignore
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var sanitize_1 = require("../../utils/sanitize");
var ButtonAction_1 = require("../ButtonAction");
var ErrorMessage_1 = require("../ErrorMessage");
var HelpText_1 = require("../HelpText");
var ChoiceCard_1 = require("./ChoiceCard");
var ChoiceCards = function (props) {
    var fieldsetAttributes = {
        className: 'form-group choicecards',
        id: props.id,
    };
    var ErrorMessageComponent;
    var HelpTextComponent;
    if (typeof props.isValid === 'boolean' && props.isValid === false) {
        // Invalid
        fieldsetAttributes.className += ' is-invalid';
        fieldsetAttributes['aria-invalid'] = true;
        // Invalid with error message
        if (props.errormessage) {
            fieldsetAttributes['aria-describedby'] = props.id + "-errormessage";
            ErrorMessageComponent = (React.createElement(ErrorMessage_1.ErrorMessage, { id: props.id, message: props.errormessage }));
        }
    }
    else if (props.helptext) {
        fieldsetAttributes['aria-describedby'] = props.id + "-helptext";
        HelpTextComponent = (React.createElement(HelpText_1.HelpText, { id: props.id }, props.helptext));
    }
    var onChange = null;
    if (typeof props.onChange === 'function') {
        onChange = function (name, value, event) {
            var updatedValues = {};
            if (props.type === 'radio') {
                updatedValues[name] = value;
            }
            else {
                updatedValues = __assign({}, props.value);
                if (value) {
                    updatedValues[name] = true;
                }
                else {
                    // Don't store false values in the object
                    delete updatedValues[name];
                }
            }
            // @ts-ignore
            props.onChange(props.name, updatedValues, event);
        };
    }
    var description = props.description;
    if (typeof description === 'string') {
        if (description.substr(0, 1) !== '<') {
            // Wrap in a paragraph if it's not inside some type of HTML
            description = "<p>" + description + "</p>";
        }
        // Sanitize HTML
        description = (React.createElement("div", { dangerouslySetInnerHTML: (0, sanitize_1.sanitize)(description) }));
    }
    var legend = (React.createElement("legend", null, props.label));
    if (props.addTabIndex) {
        legend = (React.createElement("legend", { id: props.id + "-legend", tabIndex: -1 }, props.label));
    }
    return (React.createElement("fieldset", __assign({}, fieldsetAttributes, { "data-hcid": "c002-" + process.env.REACT_APP_VERSION }),
        legend,
        description,
        HelpTextComponent,
        ErrorMessageComponent,
        React.createElement("div", { className: (0, classnames_1.default)('mb-1 mb-lg-0', { 'form-group-error mt-2 mt-lg-2': !props.isValid }, { 'pt-1 pt-lg-2 mt-4': props.isValid && !HelpTextComponent }, { 'mt-1': props.isValid && HelpTextComponent }) },
            React.createElement("div", { className: "row" }, props.options.map(function (option) {
                var name = props.type === 'radio' ? "" + props.name : props.id + "-" + option.id;
                var choicecard = {
                    checked: !!props.value[option.value],
                    children: option.children,
                    description: option.description,
                    displaySelectField: props.displaySelectField,
                    id: props.id + "-" + option.id,
                    imageSrc: option.imageSrc,
                    minimizedVersion: props.minimizedVersion,
                    name: name,
                    onChange: onChange,
                    pictogram: option.pictogram,
                    selectText: props.selectText || 'Choose',
                    smallerOnMobile: props.smallerOnMobile,
                    title: option.title,
                    type: props.type,
                    value: option.value,
                };
                return (React.createElement("div", { className: "col-12 mt-1 mb-2 mb-lg-3 " + (props.cardsGridClasses ? props.cardsGridClasses : ''), key: "choicecard-" + props.id + "-" + option.value },
                    React.createElement(ChoiceCard_1.ChoiceCard, __assign({}, choicecard))));
            }))),
        props.buttons && (React.createElement("div", { className: "pt-3" }, props.buttons.map(function (buttonAttributes, index) { return (React.createElement(ButtonAction_1.ButtonAction, __assign({}, buttonAttributes, { key: "choicecards-" + props.id + "-buttons-" + (index + 1) }))); })))));
};
exports.ChoiceCards = ChoiceCards;
/* tslint:disable:no-string-literal */
exports.ChoiceCards['defaultProps'] = {
    cardsGridClasses: 'col-md-6 col-lg-3',
    isValid: true,
};
exports.ChoiceCards['propTypes'] = {
    button: PropTypes.array,
    cardsGridClasses: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    displaySelectField: PropTypes.bool,
    errormessage: PropTypes.string,
    helptext: PropTypes.string,
    id: PropTypes.string.isRequired,
    isValid: PropTypes.bool,
    label: PropTypes.string,
    minimizedVersion: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    selectText: PropTypes.string,
    smallerOnMobile: PropTypes.bool,
    value: PropTypes.object,
};
/* tslint:enable:no-string-literal */
